import { Component, EventListener, GondelBaseComponent, triggerPublicEvent } from '@gondel/core';

/**
 * career-search module implementation.
 * @author Danijel Malinovic <danijel.malinovic@merkleinc.com>
 */

enum Selectors {
	InputField = '.js-m-search-input__input',
	SearchButton = '.js-m-search-input__button-search',
}

/**
 * Publically accessible input events from the SearchInput Gondel Component
 */
export enum SearchInputEvents {
	OnKeyPress = 'gSearchInputKeyPressEvent',
	OnSearchClick = 'gSearchEvent',
}

@Component('SearchInput')
export class SearchInput extends GondelBaseComponent {
	/**
	 * Set text from outside the component
	 */
	public set text(text: string | null) {
		if (text) {
			const searchInput = this._ctx.querySelector(Selectors.InputField) as HTMLInputElement;
			searchInput.value = text;
		}
	}

	/**
	 * Get the text from the input
	 */
	public get text(): string {
		const searchInput = this._ctx.querySelector(Selectors.InputField) as HTMLInputElement;
		return searchInput.value;
	}

	/**
	 * Listens to key events inside the input field and notifies other components about changes
	 * @param event
	 */
	@EventListener('keyup', Selectors.InputField)
	public _onKeyPress(event): void {
		const inputValue = event.target.value;
		const triggerableEvent = event.keyCode !== 13 ? SearchInputEvents.OnKeyPress : SearchInputEvents.OnSearchClick;
		triggerPublicEvent(triggerableEvent, this, undefined, { inputText: inputValue });
	}

	/**
	 * Listens to click event on the search button and notifies other components about changes
	 * @param event
	 */
	@EventListener('click', Selectors.SearchButton)
	public _onKeyDown(event: Event): void {
		const searchInput = this._ctx.querySelector(Selectors.InputField) as HTMLInputElement;
		triggerPublicEvent(SearchInputEvents.OnSearchClick, this, undefined, { inputText: searchInput.value });
	}
}
